<div [style.background-color]="coloreSnack" class="p-0 bgsnak">
  <mat-label>{{data.testo}}</mat-label>
  <button *ngIf="data.bottoneOk" mat-icon-button (click)="snackBarRef.dismiss()">
    OK
  </button>
</div>
  